import { useEffect } from 'react';
import { useLocation } from '@tanstack/react-router';
import { useTracker } from '@/lib/tracker';

export const useRouterTracking = () => {
  const location = useLocation();
  const { track } = useTracker();

  useEffect(() => {
    // Track page view on route change
    track.onPageView({
      event: 'PageView',
      page_path: location.pathname,
      page_search: location.search,
      page_hash: location.hash,
    });
  }, [location.pathname, location.search, location.hash, track]);
};
